import { useNinetailed, NinetailedProvider as NinetailedProvider$1 } from '@ninetailed/experience.js-react';
export * from '@ninetailed/experience.js-react';
export * from '@ninetailed/experience.js-plugin-ssr';
export { decodeExperienceVariantsMap } from '@ninetailed/experience.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import { useRouter } from 'next/router';
import { logger } from '@ninetailed/experience.js-shared';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

const Tracker = ({
  isFirstPageviewAlreadyTracked
}) => {
  const router = useRouter();
  const {
    page
  } = useNinetailed();
  const lastFiredPageRef = useRef(isFirstPageviewAlreadyTracked ? 'tracked' : 'none');
  useEffect(() => {
    logger.debug('Ninetailed Next.js Tracker', 'The useEffect hook to listen for route changes got called. On instantiation the last fired page is:', lastFiredPageRef.current);
    const handleRouteChange = url => {
      const isPageAlreadyTracked = lastFiredPageRef.current === url || lastFiredPageRef.current === 'tracked';
      logger.debug('Ninetailed Next.js Tracker', 'Handle route change got called.', {
        url,
        lastFiredPageUrl: lastFiredPageRef.current,
        isPageAlreadyTracked
      });
      if (!isPageAlreadyTracked) {
        logger.debug('Ninetailed Next.js Tracker', 'Page is not tracked yet, calling the ninetailed.page function.');
        page();
        logger.debug('Ninetailed Next.js Tracker', 'Page got tracked, setting the last fired page to the current url.', url);
        lastFiredPageRef.current = url;
      }
    };
    handleRouteChange(router.asPath);
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      logger.debug('Ninetailed Next.js Tracker', 'Removing the route change listener, as the useEffect hook got unmounted.');
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, []);
  return null;
};

const NinetailedProvider = _a => {
  var {
      children
    } = _a,
    props = __rest(_a, ["children"]);
  return jsxs(NinetailedProvider$1, Object.assign({}, props, {
    children: [jsx(Tracker, {
      isFirstPageviewAlreadyTracked: false
    }), children]
  }));
};

export { NinetailedProvider };
